import { Directive, Input, OnDestroy, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';
import { AppService } from 'app/services/app/app.service';
import { map, Subscription, tap } from 'rxjs';

@Directive({
    selector: '[appShowForRoles]',
    standalone: false
})
export class ShowForRolesDirective implements OnInit, OnDestroy {

  @Input('appShowForRoles') allowedRoles?: String[];
  private sub?: Subscription;

  constructor(
    private appService:AppService,
    private viewContainerRef:ViewContainerRef, 
    private templateRef:TemplateRef<any>) { }


  ngOnInit(): void {

    this.sub  = this.appService.currentUser$.pipe(
      map((user) => Boolean(user && user.roles && user.roles.find(rol => this.allowedRoles.includes(rol)))),
      tap((hasRole) => hasRole ? this.viewContainerRef.createEmbeddedView(this.templateRef): this.viewContainerRef.clear())
    ).subscribe();

  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

}
